const e=e=>{if(typeof e!=`object`||!e)return!1;let t=e;return!(typeof t.type!=`string`||`id`in t&&t.id!==void 0&&typeof t.id!=`string`)};export{e as isScopeSubject};
//# sourceMappingURL=is-scope-subject.mjs.map